module.exports = __webpack_public_path__ + "self-icon-active.9df94b7516025a7ab5de.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/self-icon-active.svg
// module id = ../../../../../src/assets/images/self-icon-active.svg
// module chunks = main